import Vue from 'vue';
import VueI18n from 'vue-i18n';
// locale files
import locale_en from '../../../lang/portal/en.json';
import locale_hu from '../../../lang/portal/hu.json';
import locale_pl from '../../../lang/portal/pl.json';
import locale_sk from '../../../lang/portal/sk.json';
import locale_nl from '../../../lang/portal/nl.json';
import locale_ru from '../../../lang/portal/ru.json';
import locale_it from '../../../lang/portal/it.json';
import locale_no from '../../../lang/portal/no.json';
import locale_lt from '../../../lang/portal/lt.json';
import locale_de from '../../../lang/portal/de.json';
import locale_fr from '../../../lang/portal/fr.json';


Vue.use(VueI18n);

const messages = {
  en: locale_en,
  hu: locale_hu,
  pl: locale_pl,
  sk: locale_sk,
  nl: locale_nl,
  ru: locale_ru,
  it: locale_it,
  no: locale_no,
  lt: locale_lt,
  de: locale_de,
  fr: locale_fr
};

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
});



// WEBPACK FOOTER //
// ./src/plugins/i18n/index.js